// extracted by mini-css-extract-plugin
module.exports = {"content":"iQ-qjiRs7_XF","text":"_3EKAzLYYGH6v","buttons":"_112iH8et-QTy","cancelButton":"_2ey9DRXwcuVU","closeButton":"dCq4B4x3m7Ik"};